import React from 'react'

export const BdayIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M7.57835 8.32806C7.41112 8.39279 7.22888 8.42853 7.03711 8.42853C6.84408 8.42853 6.6607 8.39232 6.49256 8.32677C6.24268 8.22936 6.11113 8.08714 6.03672 7.92443C5.95581 7.74748 5.92451 7.50427 5.96096 7.19431C6.03466 6.5676 6.36786 5.81773 6.77451 5.20061L7.03524 4.80494L7.29522 5.19855C7.70322 5.81625 8.03745 6.56769 8.11134 7.19545C8.1479 7.50595 8.11647 7.74939 8.03537 7.9263C7.96085 8.08888 7.82904 8.23102 7.57835 8.32806Z"
      stroke="#fff"
    />
    <path
      d="M12.5188 7.39056C12.3515 7.45529 12.1693 7.49103 11.9775 7.49103C11.7845 7.49103 11.6011 7.45482 11.433 7.38927C11.1831 7.29186 11.0516 7.14964 10.9772 6.98693C10.8962 6.80998 10.8649 6.56677 10.9014 6.25681C10.9751 5.6301 11.3083 4.88023 11.7149 4.26311L11.9757 3.86744L12.2357 4.26105C12.6437 4.87875 12.9779 5.63019 13.0518 6.25795C13.0883 6.56845 13.0569 6.81189 12.9758 6.9888C12.9013 7.15138 12.7695 7.29352 12.5188 7.39056Z"
      stroke="#fff"
    />
    <path
      d="M17.4592 8.32806C17.292 8.39279 17.1097 8.42853 16.918 8.42853C16.7249 8.42853 16.5416 8.39232 16.3734 8.32677C16.1235 8.22936 15.992 8.08714 15.9176 7.92443C15.8367 7.74748 15.8054 7.50427 15.8418 7.19431C15.9155 6.5676 16.2487 5.81773 16.6554 5.20061L16.9161 4.80494L17.1761 5.19855C17.5841 5.81625 17.9183 6.56769 17.9922 7.19545C18.0288 7.50595 17.9973 7.74939 17.9162 7.9263C17.8417 8.08888 17.7099 8.23102 17.4592 8.32806Z"
      stroke="#fff"
    />
    <path
      d="M4.14258 13.7808V15.5809C4.14258 15.8461 4.24662 16.1046 4.44549 16.2801C5.96155 17.6178 7.32233 17.4984 8.24338 17.0198C8.80294 16.729 9.55715 16.7295 10.0527 17.1194C11.473 18.2369 12.9186 18.0467 13.9614 17.2462C14.491 16.8397 15.3165 16.7604 15.8866 17.1078C16.8207 17.677 18.2589 18.0733 19.6373 16.5273C19.7855 16.3611 19.8573 16.1421 19.8573 15.9194V13.7808C19.8573 13.2285 19.4095 12.7808 18.8573 12.7808H5.14258C4.59029 12.7808 4.14258 13.2285 4.14258 13.7808Z"
      stroke="#fff"
    />
    <path
      d="M4.85742 16.8882V20.04C4.85742 20.5923 5.30514 21.04 5.85742 21.04H18.0983C18.6506 21.04 19.0983 20.5923 19.0983 20.04V17.1559"
      stroke="#fff"
    />
    <path
      d="M5.88379 12.8699V11.2806C5.88379 10.7283 6.3315 10.2806 6.88379 10.2806H7.38405C7.93634 10.2806 8.38405 10.7283 8.38405 11.2806V12.7361M10.6608 12.6915V10.3433C10.6608 9.79098 11.1086 9.34326 11.6608 9.34326H12.3394C12.8917 9.34326 13.3394 9.79098 13.3394 10.3433V12.6917M15.7055 12.7809V10.8345C15.7055 10.2822 16.1532 9.83451 16.7055 9.83451H17.384C17.9363 9.83451 18.384 10.2822 18.384 10.8345V12.7809"
      stroke="#fff"
    />
  </svg>
)

export const BranchIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <circle cx="6" cy="6" r="2.5" stroke="#fff" />
    <circle cx="6" cy="18" r="2.5" stroke="#fff" />
    <circle cx="18" cy="6" r="2.5" stroke="#fff" />
    <path
      d="M6 9V15.5C6 13.1 8.5 12 9.5 12C10.1667 12 12.1 12 14.5 12C17 12 17.8333 9.66667 18 8.5"
      stroke="#fff"
    />
  </svg>
)

export const CollegeIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M8 14.5063V17.5063V14.5063ZM12 14.5063V17.5063V14.5063ZM16 14.5063V17.5063V14.5063ZM3 21.5063H21H3ZM3 10.5063H21H3ZM3 7.50635L12 3.50635L21 7.50635H3ZM4 10.5063H20V21.5063H4V10.5063Z"
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const GradIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path d="M12 14L21 9L12 4L3 9L12 14Z" stroke="#fff" />
    <path
      d="M11.9996 14.0001L18.1596 10.5781C18.9701 12.6362 19.2001 14.8773 18.8246 17.0571C16.2882 17.3033 13.8968 18.3537 11.9996 20.0551C10.1026 18.3539 7.71167 17.3035 5.17559 17.0571C4.79979 14.8773 5.02982 12.6362 5.84059 10.5781L11.9996 14.0001Z"
      stroke="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.7572 3.56292C11.9082 3.47903 12.0918 3.47903 12.2428 3.56292L21.2428 8.56292C21.4016 8.65111 21.5 8.81842 21.5 9C21.5 9.18158 21.4016 9.34889 21.2428 9.43708L18.7789 10.8059C19.4972 12.8346 19.684 15.0162 19.3177 17.1419C19.2795 17.3639 19.0975 17.5329 18.8733 17.5547C16.443 17.7905 14.1517 18.797 12.3338 20.4272C12.1439 20.5976 11.8561 20.5976 11.6662 20.4272C10.7227 19.5812 9.65176 18.9031 8.5 18.4135V20C8.5 20.2761 8.27614 20.5 8 20.5C7.72386 20.5 7.5 20.2761 7.5 20V18.0424C6.73295 17.7978 5.93803 17.6334 5.12765 17.5547C4.90348 17.5329 4.72153 17.3639 4.68327 17.1419C4.31683 15.0164 4.50352 12.8349 5.22189 10.8064L2.75718 9.43708C2.59845 9.34889 2.5 9.18158 2.5 9C2.5 8.81842 2.59845 8.65111 2.75718 8.56292L11.7572 3.56292ZM6.10943 11.2994C5.5337 13.0036 5.36269 14.8196 5.61122 16.603C6.25266 16.6857 6.88402 16.8178 7.5 16.9971V12.5C7.5 12.3677 7.55227 12.243 7.64204 12.1509L6.10943 11.2994ZM8.5 12.7942V17.3347C9.76543 17.8226 10.9489 18.5164 12 19.3939C13.8203 17.8744 16.0373 16.9058 18.3897 16.603C18.6381 14.8195 18.467 13.0035 17.8914 11.2992L12.2428 14.4371C12.0918 14.521 11.9082 14.521 11.7572 14.4371L8.65002 12.7109L8.5 12.7942ZM12 13.428L19.9704 9L12 4.57198L4.02956 9L6.06875 10.1329C6.07382 10.1355 6.07885 10.1382 6.08384 10.1409L8.65022 11.5668L11.7572 9.84091C11.9986 9.70681 12.303 9.7938 12.4371 10.0352C12.5712 10.2766 12.4842 10.581 12.2428 10.7151L9.67976 12.1389L12 13.428Z"
      fill="#fff"
    />
  </svg>
)

export const ResumeIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M9 12.5063H15H9ZM9 16.5063H15H9ZM17 21.5063H7C6.46957 21.5063 5.96086 21.2956 5.58579 20.9206C5.21071 20.5455 5 20.0368 5 19.5063V5.50635C5 4.97591 5.21071 4.46721 5.58579 4.09213C5.96086 3.71706 6.46957 3.50635 7 3.50635H12.586C12.8512 3.5064 13.1055 3.6118 13.293 3.79935L18.707 9.21335C18.8946 9.40084 18.9999 9.65515 19 9.92035V19.5063C19 20.0368 18.7893 20.5455 18.4142 20.9206C18.0391 21.2956 17.5304 21.5063 17 21.5063Z"
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
